import { TribesState, State } from "vue";
import { Module } from "vuex";

import createTribeModule from "./tribesAbstract";

export default function createInternalStoreModule(): Module<
  TribesState,
  State
> {
  return createTribeModule("internal");
}
